"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identify = exports.initialize = exports.checkout = exports.prequalify = void 0;
var tslib_1 = require("tslib");
var initialize_1 = require("./lib/initialize");
Object.defineProperty(exports, "initialize", { enumerable: true, get: function () { return initialize_1.initialize; } });
var launchChargeafterUi_1 = require("./lib/launchChargeafterUi");
var prequalify = function (_a) {
    var config = _a.config, opt = tslib_1.__rest(_a, ["config"]);
    return (0, launchChargeafterUi_1.launchChargeafterUi)(tslib_1.__assign({ config: config, checkout: false }, opt));
};
exports.prequalify = prequalify;
var checkout = function (_a) {
    var config = _a.config, opt = tslib_1.__rest(_a, ["config"]);
    return (0, launchChargeafterUi_1.launchChargeafterUi)(tslib_1.__assign({ config: config, checkout: true }, opt));
};
exports.checkout = checkout;
/**
 * @description - This method is used to launch the identification modal,
 * a modal that collects the consumer's information e.g license number, expiry date, etc.
 *
 * @param {IdentifyOpt} data - the config and opt for the modal
 * @returns identification token that should be passed in the prequalify or checkout method inside opt
 */
var identify = function (_a) {
    var config = _a.config, opt = _a.opt, onModalOpen = _a.onModalOpen;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var caConfig, chargeafter;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    caConfig = {
                        apiKey: config.env.apiKey,
                        delegatedMerchantId: config.env.delegatedMerchantId,
                        storeId: config.storeId,
                        onLoaded: onModalOpen,
                    };
                    return [4 /*yield*/, (0, initialize_1.initialize)(caConfig, config.env.name)];
                case 1:
                    chargeafter = _b.sent();
                    return [4 /*yield*/, chargeafter.identification.present(opt)];
                case 2: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.identify = identify;
